export interface IMassUploadItemError {
  fieldId: string;
  errorCode: string;
}

export enum MassUploadItemStatus {
  Created = 'Created',
  Closed = 'Closed',
  ClosedWithFailures = 'ClosedWithFailures'
}

export enum MassUploadStatus {
  Created = 'Created',
  InProgress = 'InProgress',
  Closed = 'Closed',
  ClosedWithFailures = 'ClosedWithFailures'
}

export interface IMassUploadItem {
  id: number;
  firstName: string;
  lastName: string;
  emailAddress: string;
  status: MassUploadItemStatus;
  errors: IMassUploadItemError[];
}

export interface IMassUploadSummary {
  requestCreated: string;
  requestStatusUpdate: string;
  totalCount: number;
  created: number;
  updated: number;
  unchanged: number;
  failed: number;
  status: MassUploadStatus;
}

export interface IMassUploadDetails {
  summary: IMassUploadSummary;
  items: {
    currentPage: number;
    rowsPerPage: number;
    totalCount: number;
    totalPages: number;
    items: IMassUploadItem[];
  };
}
